import ListingCard from "../components/ListingCard";

function FavoritesPage({
  error,
  favoriteActionListingId,
  favorites,
  isLoading,
  onOpenListing,
  onToggleFavorite,
}) {
  return (
    <section className="main-panel">
      <div className="page-heading">
        <div>
          <span className="mini-label">Favoritter</span>
          <h1>Gemte annoncer</h1>
          <p>Hold styr på de annoncer, du gerne vil vende tilbage til.</p>
        </div>
        <div className="summary-card">
          <strong>{favorites.length}</strong>
          <span>gemte annoncer</span>
        </div>
      </div>

      {error && <p className="status-line error">{error}</p>}

      {isLoading ? (
        <div className="empty-results">Henter favoritter...</div>
      ) : favorites.length === 0 ? (
        <div className="empty-results">
          <strong>Ingen favoritter endnu</strong>
          <p>Tryk på hjertet ved en annonce for at gemme den her.</p>
        </div>
      ) : (
        <div className="listing-grid">
          {favorites.map((listing) => (
            <ListingCard
              favoriteActionListingId={favoriteActionListingId}
              key={listing.id}
              listing={listing}
              onOpen={onOpenListing}
              onToggleFavorite={onToggleFavorite}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default FavoritesPage;
